export const navLinks = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Gallery", href: "#gallery" },
  { label: "Testimonials", href: "#testimonials" },
];

export const heroData = {
  badge: "Premium Grooming",
  headingLine1: "CRAFTING CONFIDENCE,",
  headingLine2: "ONE CUT AT A TIME.",
  subtitle:
    "Experience precision fades, sharp line-ups, and an unmatched vibe at our premium barbershop.",
  ctaPrimary: { label: "VISIT US", href: "#contact" },
  ctaSecondary: { label: "OUR SERVICES", href: "#services" },
  image:
    "https://zgnpmogdjnnhpwewavnr.supabase.co/storage/v1/object/public/project-images/c49125a9-44f7-41c2-bee7-a26ecc94d44c/1776177397429-xmkt8f.png",
  imageAlt: "Premium Barbershop Haircut",
};

export const services = [
  {
    icon: "Scissors",
    title: "Skin Fades",
    description:
      "Flawless transitions down to the bone. Sharp, clean, and perfectly blended.",
  },
  {
    icon: "Zap",
    title: "Line Ups",
    description:
      "Razor sharp edges that frame your face. Precision geometry for a striking look.",
  },
  {
    icon: "Flame",
    title: "Wax & Ear Flame",
    description:
      "Precision nose and ear waxing paired with traditional ear flaming for a clean, polished finish.",
  },
  {
    icon: "Droplets",
    title: "Restyle",
    description:
      "Complete transformation. Consultation, wash, cut, and premium product styling.",
  },
  {
    icon: "Wind",
    title: "Hot Towel & Steam Shave",
    description:
      "Luxury hot towel wrap followed by a precise steam shave. The ultimate relaxation for your skin.",
  },
  {
    icon: "Coffee",
    title: "Free Traditional Tea & Coffee",
    description:
      "Sit back, relax and enjoy a complimentary traditional tea or freshly brewed coffee with every visit.",
  },
  {
    icon: "SmilePlus",
    title: "Kids Cut",
    description:
      "Fun, patient and gentle haircuts for the little ones. We make sure every kid leaves with a smile.",
  },
  {
    icon: "HeartHandshake",
    title: "Pension Cuts",
    description:
      "Special rates for our senior clients. Quality grooming and a warm welcome, always.",
  },
];

export const aboutData = {
  badge: "New Era Barbers",
  headingPart1: "Not your",
  headingHighlight: "grandpa's",
  headingPart2: "barbershop.",
  description:
    "Golden Scissors was born from a rebellion against boring, rushed haircuts. We are a sanctuary for the modern aesthetic\u2014where 3D texture meets razor-sharp precision. Our space is loud, our fades are immaculate, and our vibe is unmatched.",
  stats: [
    { value: "10k+", label: "Fades Delivered" },
    { value: "4.8", label: "Star Rating" },
  ],
  image:
    "https://zgnpmogdjnnhpwewavnr.supabase.co/storage/v1/object/public/project-images/c49125a9-44f7-41c2-bee7-a26ecc94d44c/1776177343523-k8apd.png",
  imageAlt: "Edgy modern barbershop interior",
};

export const galleryItems = [
  {
    image:
      "https://customer-assets.emergentagent.com/job_scissors-shop-1/artifacts/6lc3clhv_Gemini_Generated_Image_8xmmdk8xmmdk8xmm.png",
    alt: "Skin fade haircut",
    title: "Zero Skin Fade",
    subtitle: "Textured top, razor finish",
    large: true,
  },
  {
    image:
      "https://zgnpmogdjnnhpwewavnr.supabase.co/storage/v1/object/public/project-images/c49125a9-44f7-41c2-bee7-a26ecc94d44c/1776177961492-pbikewsk.png",
    alt: "Textured crop haircut",
    title: "Textured Crop",
    subtitle: "",
    large: false,
  },
  {
    image:
      "https://zgnpmogdjnnhpwewavnr.supabase.co/storage/v1/object/public/project-images/c49125a9-44f7-41c2-bee7-a26ecc94d44c/1776178275613-ci4u6.png",
    alt: "Beard trim",
    title: "Beard Sculpt",
    subtitle: "",
    large: false,
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_scissors-shop-1/artifacts/e0y75xzj_WhatsApp%20Image%202026-04-15%20at%2020.20.08%20%281%29.jpeg",
    alt: "Waxing treatment",
    title: "Waxing",
    subtitle: "",
    large: false,
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_scissors-shop-1/artifacts/yfee6xv0_WhatsApp%20Image%202026-04-15%20at%2020.20.08.jpeg",
    alt: "Ear flame treatment",
    title: "Ear Flame",
    subtitle: "",
    large: false,
  },
];

export const testimonials = [
  {
    rating: 5,
    text: "The attention to detail is insane. Best fade I've ever had, hands down. The vibe in the shop is next level too.",
    initial: "A",
    name: "Alex R.",
    label: "Verified Client",
  },
  {
    rating: 5,
    text: "Finally found a barber who actually listens and delivers. Golden Scissors is the real deal. Worth every penny.",
    initial: "J",
    name: "Jamal K.",
    label: "Verified Client",
  },
  {
    rating: 5,
    text: "Came in for a complete restyle and left feeling like a new person. The skill and artistry here are unmatched. Highly recommend.",
    initial: "S",
    name: "Sam T.",
    label: "Verified Client",
  },
];

export const contactData = {
  headingPart1: "Visit The",
  headingHighlight: "Shop",
  subtitle:
    "Step into our world. Find us in the heart of the city, ready to craft your next look.",
  location: {
    title: "Location",
    lines: ["50 St Mary's Rd, Market Harborough", "LE16 7DU, United Kingdom"],
  },
  phone: {
    title: "Phone",
    number: "+441858288230",
    display: "+44 1858 288230",
  },
  hours: {
    title: "Hours",
    lines: [
      "Mon - Wed: 9am - 6pm",
      "Thu - Fri: 9am - 7pm",
      "Saturday: 8am - 6pm",
      "Sunday: 10am - 4pm",
    ],
  },
  mapUrl:
    "https://www.google.com/maps/place/Golden+Scissors+-+Market+Harborough/@52.4779135,-0.9199705,17z/data=!3m1!4b1!4m6!3m5!1s0x4877712e39f197b1:0xb883aef2750aabdb!8m2!3d52.4779135!4d-0.9173956!16s%2Fg%2F11gsbk8gn0?entry=ttu&g_ep=EgoyMDI2MDQxMi4wIKXMDSoASAFQAw%3D%3D",
  mapLabel: "Get Directions on Google Maps",
};
